import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from '../store';
import { ConfigProvider } from '../contexts/ConfigContext';
import { BASE_PATH } from '../config';
import { ReactNode } from 'react';

const AppWrapper = ({ children }: { children: ReactNode }) => {
    return (
        <Provider store={store}>
            <ConfigProvider>
                <BrowserRouter basename={BASE_PATH}>{children}</BrowserRouter>
            </ConfigProvider>
        </Provider>
    );
};

export default AppWrapper;
